<template>
  <div>
    <com-nav
      :info="$store.state.info"
      :logoImg="logoImg"
      :type="homeData.nav.version"
      ></com-nav>

    <router-view></router-view>

    <!-- footer && other-section -->
    <template v-if="$route.name!=='promo'&&$route.name!=='promoSub'">
      <!-- 底部 -->
      <com-footer
      :qrcodeI="qrcodeInfoq"
      :qrcodeII="comConfig.WeChatOfficialAccounts"
      :contacts="info.contacts"
      :map="{...info.address}"
      >
        <div slot="mobile-footer-logo"></div>
      </com-footer>

      <!-- pc端常驻二维码 -->
      <com-fix :weChatOfficialAccounts="comConfig.WeChatOfficialAccounts"></com-fix>

      <!-- 广告 -->
      <com-ad v-if="timeShowRule&&pageShowRule&&Boolean($store.state.ads.length)" :ads="ad" :primary-color="primaryColor"></com-ad>

      <!-- 浮窗 -->
      <com-floating-win class="display-mobile" :info="{...comConfig.comFloatWin}"></com-floating-win>
    </template>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import ComNav from 'gkConUI/com-nav'
import ComFooter from 'gkConUI/com-footer-pro'
import ComFix from 'gkConUI/com-fix'
import ComAd from 'gkConUI/com-ad'
import ComFloatingWin from 'gkConUI/com-floating-win'

import service from 'gkCon/service'
import config from '@/config'
import utils from '@/utils'

export default {
  name: 'app',
  components: {
    ComNav,
    ComFooter,
    ComFix,
    ComAd,
    ComFloatingWin
  },
  data () {
    return {
      showCompany: false,
      timeShowRule: true,
      havaData: false,
      isDisplayAds: true,
      qrcodeInfoq: require('common/assets/img/qrcode-infoq.png')
    }
  },
  created () {
    /**
     * set website info
     * 如：网站标题：ArchuSummit深圳2020|全球架构师峰会
     *    关键词：ArchSummit,InfoQ,全球架构师峰会,2020,深圳
     */
    utils.setWebsiteBaseInfo({
      title: `${this.comConfig.websiteTitleEN}${this.comConfig.location.CH}${this.conKeyInfo.year}|${this.comConfig.websiteTitle}`,
      keywords: `${this.comConfig.keywords},${this.conKeyInfo.year},${this.comConfig.location.CH}`
    })

    // screen width
    this.setDevice(this.getScreenWidth())

    // 获取大会 JSON 地址及请求 JSON
    this.getData()
  },
  mounted () {
    // 设置设备宽度
    window.onresize = () => {
      this.setDevice(this.getScreenWidth())
    }

    // 设置主题色
    this.updateThemeForStyle()

    // 微信分享
    utils.initWxConfig()
  },
  computed: {
    ...mapState({
      comConfig: 'comConfig',
      conKeyInfo: 'conKeyInfo',
      info: 'info'
    }),
    homeData () {
      return this.$store.state.comConfig['home']
    },
    logoImg () {
      return this.comConfig.logo
    },
    bgColor () {
      // let { location, year, con } = this.conKeyInfo
      // let s = `${location}/${year}`
      // console.log(s)
      // if (s === 'shanghai/2019') return '#363D73'
      // else if (s === 'xiamen/2019') return '#7CBEED'
      // else if (s === 'beijing/2018') return '#000000'
      // else if (con === 'as' && s == 'beijing/2019') return '#1f63af'
      // else return '#363D73'
      return '#1f63af'
    },
    pageShowRule () {
      let displayPage = this.$store.state.ads[0] ? Number(this.$store.state.ads[0].display_page) : 0
      if (displayPage === 2 && this.$route.name !== 'apply') {
        return true
      } else if (displayPage === 2 && this.$route.name === 'apply') {
        return false
      } else if (displayPage === 3 && this.$route.name === 'home') {
        return true
      } else if (displayPage === 3 && this.$route.name !== 'home') {
        return false
      } else {
        return true
      }
    },
    ad () {
      let arr1 = this.$store.state.ads || []
      let arr2 = []
      if (arr1.length) {
        arr1.forEach((item) => {
          arr2.push(Number(item.percentage))
        })
      }
      return utils.randomFn(arr1, arr2)
    },
    primaryColor () {
      return this.conKeyInfo['theme']['--primary-color']
    }
  },
  methods: {
    ...mapMutations({
      setDevice: 'SET_DEVICE',
      parseConData: 'PARSE_CON_DATA'
    }),
    /**
     * 获取大会JSON地址及请求JSON
     */
    getData () {
      // 装载大会核心数据
      let data = JSON.stringify({
        location_en: this.conKeyInfo.location,
        time: this.conKeyInfo.year,
        category: config['CON_NAME_MAP_ID'][this.conKeyInfo.con]
      })
      // 获取数据源地址
      service.getConsList(data)
        .then((res) => {
          if (Number(res.status) !== 0) {
            this.havaData = true
            // 请求数据
            service.getConData(res.json)
              .then(res => {
                // 解析数据
                this.parseConData(res)
              })
              .catch(() => { console.log('请求 data.json 出错') })
          } else {
            // console.log(config.defaultCon, 'aaaaaaa')
            // return
            // 重定向到指定大会
            let href = `https://${config.defaultCon.con}.infoq.cn/${config.defaultCon.year}/${config.defaultCon.location}`
            if (href !== window.location.href) {
              window.location.href = href
            } else {
              alert('网站未上线')
            }
          }
        })
        .catch(() => {
          console.log('请求大会列表出错')
        })
    },
    getScreenWidth () {
      let screenWidth = 0
      if (window.innerWidth) {
        screenWidth = window.innerWidth
      } else if ((document.body) && (document.body.clientWidth)) {
        screenWidth = document.body.clientWidth
      }
      return screenWidth
    },
    /**
     * 给 app 设置主题颜色
     */
    updateThemeForStyle () {
      const selectedTheme = this.conKeyInfo['theme']
      const html = document.getElementsByTagName('html')[0]
      Object.keys(selectedTheme).forEach((property, i) => {
        if (property === 'name') {
          html.style.setProperty('--theme', selectedTheme[property])
          return
        }
        html.style.setProperty(property, selectedTheme[property])
      })
    }
  },
  watch: {
    '$store.state.ads': {
      handler: function (val, oldVal) {
        let duration = val[0] ? Number(val[0].duration) : -1
        if (duration === 0) {
          this.isDisplayAds = true
          window.setTimeout(() => { this.isDisplayAds = false }, 30000)
        } else if (duration === -1) {
        } else {
          window.setTimeout(() => { this.isDisplayAds = false }, duration * 1000)
        }
      }
    }
  }
}
</script>

<style lang="sass">
@import "./style/variable"
@import "./style/generic"
@import "./style/layout"
@import "./style/component"
// @import "./style/iconfont/iconfont"
// @import "./style/iconfont/v4/iconfont.css"
@import "~gkCon/assets/style/iconfont/iconfont.css"

body
  padding-top: $nav-height
  +tablet
    padding-top: $nav-height-pc
  +mobile
    -webkit-text-size-adjust: 100%
.fade-enter-active, .fade-leave-active
  transition: opacity 0.4s
.fade-enter, .fade-leave-to
  opacity: 0
</style>
